import { Injectable } from '@angular/core';
import { Headers, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class CouponCodeClientService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private url = 'api/couponCodeClient';

    constructor(private http: Http) { }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    saveExcelData(data: any): Promise<any> {
        const url = `${this.url}/saveExcelData`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    addUpdateRecord(data: any): Promise<any> {
        const url = `${this.url}/addUpdateRecord`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    deleteRecord(id: any): Promise<any> {
        const url = `${this.url}/deleteRecord`;
        return this.http
            .post(url, $.param({ id: id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getClientByMobile(mobile: string): Observable<any> {
        const url = `${this.url}/getClientByMobile`;
        let params = new URLSearchParams();
        params.set('mobile', mobile);
        return this.http.get(url, { search: params }).map(res => res.json());
    }

    getActiveCouponCodes(): Promise<any> {
        const url = `${this.url}/getActiveCouponCodes`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    updateStatus(data: any): Promise<any> {
        const url = `${this.url}/updateStatus`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getCouponCodeClientList(query: any): Promise<any> {
        const url = `${this.url}/getCouponCodeClientList`;
        let params = new URLSearchParams();
        Object.keys(query).forEach(key => params.set(key, query[key]));
        return this.http
            .get(url, { search: params })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/couponCodeClient.service.ts